import React, { Component } from 'react';
import { Link } from '../../shared/lib/nextCompat';
import { ContentfulImage } from '../../../features/Contentful/ContentfulImage';
import { ContentfulAsset } from '../../../features/Contentful';
import { BlogPostPreviewContainer } from './styles';
import { TFunction, useT } from '@spotify-internal/i18n-core';
import { useDateTimeFormatter } from '../../../../features/src/i18n';
import { ImageAspectBox16x9 } from '../../../features/ui';
import { Type } from '@spotify-internal/encore-web-v5';

type BlogPostPreviewProps = {
  urlSlug: string;
  title: string;
  releaseDate: string;
  description: string;
  featuredAsset?: ContentfulAsset;
};

type BlogPostPreviewClassComponentProps = BlogPostPreviewProps & {
  releaseDateLocalized: string;
  t: TFunction;
};

class BlogPostPreviewClassComponent extends Component<BlogPostPreviewClassComponentProps> {
  render() {
    return (
      <BlogPostPreviewContainer
        key={this.props.urlSlug}
        id={this.props.urlSlug}
      >
        {this.props.featuredAsset && (
          <Link href={`/blog/${this.props.urlSlug}`}>
            <a>
              <ImageAspectBox16x9>
                <ContentfulImage
                  asset={this.props.featuredAsset}
                  placeholder={false}
                />
              </ImageAspectBox16x9>
            </a>
          </Link>
        )}
        <time dateTime={this.props.releaseDate}>
          {this.props.releaseDateLocalized}
        </time>
        <Type as="h2" variant="altoBrio">
          <Link href={`/blog/${this.props.urlSlug}`}>
            <a>{this.props.title}</a>
          </Link>
        </Type>
        <Type as="p" variant="ballad" className="lead">
          {this.props.description}
        </Type>
        <Link href={`/blog/${this.props.urlSlug}`}>
          <a
            className="btn btn-link"
            data-testid={`blog-preview-${this.props.urlSlug}`}
          >
            {this.props.t('FRODOR_e19dcd', 'Read more', '')}
          </a>
        </Link>
      </BlogPostPreviewContainer>
    );
  }
}

const BlogPostPreview = (props: BlogPostPreviewProps) => {
  const t = useT();
  const dateFormatter = useDateTimeFormatter();
  const releaseDateLocalized = dateFormatter.format(
    new Date(props.releaseDate),
  );
  return (
    <BlogPostPreviewClassComponent
      {...props}
      t={t}
      releaseDateLocalized={releaseDateLocalized}
    />
  );
};

export default BlogPostPreview;
